import React, { useState } from 'react';
import {
	Card,
	Tabs,
} from 'antd';
import { FeatureFlags } from '@shared/utils/constants';
import SimpleScreen from '@client/components/screens/SimpleScreen';
import FixingCompanies from '@client/screens/management/banking/FixingCompanies';
import VesselsBank from '@client/screens/management/banking/VesselsBank';
import ApprovalSettings from '@client/screens/management/approvals/ApprovalSettings';
import UserManagement from '@client/screens/management/users/UserManagement';
import ReportGroups from '@client/screens/management/report-groups/ReportGroups';
import useFeatureFlag from '@client/utils/hooks/useFeatureFlag';
import { useNavigationBlock } from '@client/lib/navigationBlock';
import AccrualSettings from '../accruals/AccrualSettings';
import OffHireTypes from '../off-hire-types/OffHireTypes';
import EstimatorSettings from '../estimator/EstimatorSettings';
import GeneralSettings from '../general/GeneralSettings';
import Invoicing from '../invoicing/Invoicing';
import ManualAccrualMapping from '../accruals/ManualAccrualMapping';
import PortActivities from '../port-activities/PortActivities';
import PortCostCategories from '../port-cost-categories/PortCostCategories';
import AlbaSettings from '../alba/AlbaSettings';
import CargoTypesSettings from '../cargo-types/CargoTypesSettings';
import styles from './ManagementSettingsScreen.module.css';

const ManagementSettingsScreen = () => {
	const [activeTab, setActiveTab] = useState('approvals');
	const isAlba = useFeatureFlag(FeatureFlags.ALBA);
	const { makeBlockable } = useNavigationBlock();

	return (
		<SimpleScreen
			title="Company Settings"
			rootPageTitle="Company Settings"
		>
			<Card>
				<Tabs
					onChange={makeBlockable(setActiveTab)}
					activeKey={activeTab?.toString()}
					items={[
						{
							key: 'approvals',
							label: 'Approvals',
							children: (<ApprovalSettings />),
						},
						{
							key: 'users',
							label: 'Team Members',
							children: (<UserManagement />),
						},
						{
							key: 'companyAndBank',
							label: 'Comp. & bank',
							children: (<FixingCompanies />),
						},
						{
							key: 'vesselsBank',
							label: 'Vessels bank',
							children: (
								<div className={styles.bankingContainer}>
									<VesselsBank />
								</div>
							),
						},
						{
							key: 'accruals',
							label: 'Accruals',
							children: (<AccrualSettings />),
						},
						{
							key: 'accrualMapping',
							label: 'Accrual Mapping',
							children: (<ManualAccrualMapping />),
						},
						{
							key: 'reportGroups',
							label: 'Report Groups',
							children: (<ReportGroups />),
						},
						{
							key: 'offHireTypes',
							label: 'Off-hire Types',
							children: (<OffHireTypes />),
						},
						{
							key: 'estimatorSettings',
							label: 'Estimator',
							children: (<EstimatorSettings />),
						},
						{
							key: 'generalSettings',
							label: 'General',
							children: (<GeneralSettings />),
						},
						{
							key: 'invoicing',
							label: 'Invoicing',
							children: (
								<div className={styles.invoicingContainer}>
									<Invoicing />
								</div>
							),
						},
						{
							key: 'portActivites',
							label: 'Port Activities',
							children: (<PortActivities />),
						},
						{
							key: 'portCostReporting',
							label: 'Port Cost Reporting',
							children: (<PortCostCategories />),
						},
						{
							key: 'cargoTypes',
							label: 'Cargo Types',
							children: (<CargoTypesSettings />),
						},
						...(isAlba ? [{
							key: 'alba',
							label: 'Alba',
							children: (<AlbaSettings />),
						}] : []),
					]}
				/>
			</Card>
		</SimpleScreen>
	);
};

export default ManagementSettingsScreen;
